/**
 * bomLibraryImportBean.js — the `ImportFile` bean of the library import (contrato-sun.md §8): the
 * generic `PUT /endpoints/import` parks the CSV lines in the `importScopeUUID` passed as extra param,
 * and nothing is persisted until N13 commits (or N14 discards) that scope. Columns are identical to
 * `ImportWorkflowResource` + `extended_column1..12`.
 */
export const BOM_LIBRARY_IMPORT_BEAN = {
  beanDtoName: 'ImportBillOfMaterialsLibrary',
  beanDtoPackage: 'com.smartpm.sun.usecase.bomlibrary.infrastructure.csv',
  beanName: 'ImportBillOfMaterialsLibrary',
  beanPackage: 'com.smartpm.sun.usecase.bomlibrary.infrastructure.csv',
  serviceName: 'ImportBillOfMaterialsLibraryCsv',
  servicePackage: 'com.smartpm.sun.usecase.bomlibrary.infrastructure.csv'
}
